import React, { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

import { Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import MyCollapse from 'components/Collapse';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';
import shoppingService from 'v2/services/shopping/subscription';

import { TABLE_STATUS_BASE, getStatusColor } from '../statusColors';

interface PaymentHistoryProps {
  delivery: ShoppingDelivery;
}

export const PaymentHistory = ({ delivery }: PaymentHistoryProps) => {
  const [loadingHistory, setLoadingDocument] = useState<boolean>(false);
  const [history, setHistory] = useState<any[]>([]);

  const handleClickHistory = useCallback((subscriptionId: number) => {
    setLoadingDocument(true);
    shoppingService.loadSubscriptionHistory(subscriptionId).subscribe(res => {
      setHistory(res.data);
      setLoadingDocument(false);
    }, toast.error);
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: '',
      key: 'status',
      width: 20,
      render: (_, record) => (
        <Tooltip placement='top' title={record.payment_status.name}>
          <div className={`${TABLE_STATUS_BASE} ${getStatusColor(record.payment_status.alias)}`} />
        </Tooltip>
      )
    },
    {
      title: 'Fatura',
      key: 'id',
      dataIndex: 'id'
    },
    {
      title: 'Pagamento',
      key: 'received_at',
      render: (_, record) =>
        record.received_at ? dateService.dateToString(new Date(record.received_at), 'dd/MM/yyyy') : '-'
    },
    {
      title: 'Valor',
      key: 'amount',
      align: 'right',
      render: (_, record) => record.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  ];

  return (
    <MyCollapse title='Histórico de Pagamento' onClick={() => handleClickHistory(delivery.subscription_id)} arrow>
      <Table
        columns={columns}
        dataSource={history}
        rowKey='id'
        loading={loadingHistory}
        pagination={false}
        size='small'
      />
    </MyCollapse>
  );
};
